// FILE PATH: eRFQFrontend/src/App.js

import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import ProtectedRoute from "./middleware/ProtectedRoute";
import Login from "./component/Login";
import ForgotPassword from "./component/ForgotPassword";
import SuperadminDashboard from "./component/Superadmin/SuperadminDashboard";
import AllOrgs from "./component/Superadmin/AllOrgs";
import CreateOrg from "./component/Superadmin/CreateOrg";
import EditOrg from "./component/Superadmin/EditOrg";
import EditAdmin from "./component/Superadmin/EditAdmin";
import AdminDashboard from "./component/Admin/AdminDashboard";
import AllOrgsUsers from "./component/Admin/AllOrgUsers";
import CreateUser from "./component/Admin/CreateUser";
import OrgDetails from "./component/Admin/OrgDetails";
import UserDashboard from "./component/Users/UserDashboard";
import Dashboard from "./component/Users/Dashboard";
import AllVendors from "./component/Admin/AllVendors";
import AddVendor from "./component/Admin/AddVendor";
import RFQCreation from "./component/Users/Buyer/RFQCreation/RFQCreation";
import OrgCurrency from "./component/Admin/OrgCurrency";
import VendorDetails from "./component/Vendor/VendorDetails";
import VendorDashboard from "./component/Vendor/VendorDashboard";
import MyRFQs from "./component/Vendor/MyRFQs";
import BidSubmission from "./component/Vendor/BidSubmission/BidSubmission";
import ViewRFQ from "./component/Users/ViewRFQ";
import ViewAllBids from "./component/Users/ViewAllBids";
import ViewRFQDetails from "./component/Vendor/ViewRFQDetails";
import ViewQueries from "./component/Vendor/ViewQueries";
import AskQuery from "./component/Vendor/AskQuery";
import QueriesTab from "./component/Users/Buyer/Query/QueriesTab";
import VendorSignUp from "./component/Vendor/VendorSignUp";
import RebidSubmission from "./component/Vendor/RebidSubmission/RebidSubmission";
import Currency from "./component/Superadmin/Currency";
import Units from "./component/Superadmin/Units";
import ViewVendorBids from "./component/Vendor/ViewVendorBids";
import { useEffect } from "react";
import axios from "axios";
import OrgUsers from "./component/Superadmin/Admin Dashboard/OrgUsers";
import CreateOrgUser from "./component/Superadmin/Admin Dashboard/CreateOrgUser";
import Vendors from "./component/Superadmin/Admin Dashboard/Vendors";
import CreateVendor from "./component/Superadmin/Admin Dashboard/CreateVendor";
import AddCurrency from "./component/Superadmin/Admin Dashboard/AddCurrency";
import OrgDetailsBySuperadmin from "./component/Superadmin/Admin Dashboard/OrgDetailsBySuperadmin";
import OrgDepartment from "./component/Admin/OrgDepartment";
import Department from "./component/Superadmin/Admin Dashboard/Department";

// LOGISTICS BUYER IMPORTS
import BuyerSelection from "./component/Logistic/BuyerSelection";
import LogisticDashboard from "./component/Logistic/Buyer/LogisticDashboard";
import LogisticCreate from "./component/Logistic/Buyer/LogisticCreation/LogisticCreate";
import ViewLogisticDraftDetails from "./component/Logistic/Buyer/ViewLogisticDraftDetails";

// LOGISTICS PURCHASE HEAD AND CXO IMPORTS
import LogisticPurchaseHeadDashboard from "./component/Logistic/Purchase Head/LogisticPurchaseHeadDashboard";
import LogisticCXODashboard from "./component/Logistic/CXO/LogisticCXODashboard";

// LOGISTICS VENDOR IMPORTS
import VendorLogisticsDashboard from "./component/Vendor/LogisticDashboard/MyLogistics";
import ViewLogisticRFQDetails from "./component/Vendor/LogisticViewRFQ/ViewLogisticRFQDetails";
import ViewLogisticQuote from "./component/Vendor/LogisticViewRFQ/ViewLogisticQuote";
import LogisticBidSubmission from "./component/Vendor/LogisticBidSubmission/LogisticBidSubmission";
import LogisticRebidSubmission from "./component/Vendor/LogisticRebidSubmission/LogisticRebidSubmission";
import ViewLogisticQuotes from "./component/Logistic/ViewLogisticQuotes";
import LogisticQueriesTab from "./component/Logistic/Buyer/Query/QueriesTab";
import OrgCity from "./component/Admin/OrgCity";
import City from "./component/Superadmin/Admin Dashboard/City";

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkSubscription = async () => {
      const user = JSON.parse(localStorage.getItem("user"));
      const today = new Date().toISOString().split("T")[0];

      if (!user) return;

      try {
        if (user.userRole[0] !== "SUPERADMIN" && user.userRole[0] !== "VENDOR") {
          const url =
            user.userRole[0] === "ADMIN"
              ? `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${user.username}`
              : `${process.env.REACT_APP_BACKEND_URL}/org-user/get-org?username=${user.username}`;

          const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${user.accessToken}` },
          });

          if (res.data.subscriptionEndDate < today) {
            alert("Your subscription has ended.");
            localStorage.clear();
            navigate("/");
          }
        }
      } catch (e) {
        localStorage.clear();
        navigate("/");
      }
    };

    checkSubscription();
  }, [location.pathname]);

  useEffect(() => {
    const wheelHandler = (e) => {
      if (document.activeElement.matches("input[type=number]")) {
        e.preventDefault();
      }
    };

    const keyHandler = (e) => {
      if (
        document.activeElement.matches("input[type=number]") &&
        (e.key === "ArrowUp" || e.key === "ArrowDown")
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener("wheel", wheelHandler, { passive: false });
    window.addEventListener("keydown", keyHandler);

    return () => {
      window.removeEventListener("wheel", wheelHandler);
      window.removeEventListener("keydown", keyHandler);
    };
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/user-onboarding" element={<ForgotPassword />} />
      <Route path="/signup" element={<VendorSignUp />} />

      {/* SUPERADMIN ROUTES */}
      <Route element={<ProtectedRoute allowedRoles={["SUPERADMIN"]} />}>
        <Route path="/superadmin-dashboard" element={<SuperadminDashboard />}>
          <Route index element={<AllOrgs />} />
          <Route path="create-org" element={<CreateOrg />} />
          <Route path=":orgId" element={<EditOrg />} />
          <Route path=":orgId/admin" element={<EditAdmin />} />
          <Route path="currency" element={<Currency />} />
          <Route path="unit" element={<Units />} />
          <Route path=":orgId/admin-dashboard" element={<OrgUsers />} />
          <Route path=":orgId/admin-dashboard/create-user" element={<CreateOrgUser />} />
          <Route path=":orgId/admin-dashboard/vendor" element={<Vendors />} />
          <Route path=":orgId/admin-dashboard/vendor/create-vendor" element={<CreateVendor />} />
          <Route path=":orgId/admin-dashboard/currency" element={<AddCurrency />} />
          <Route path=":orgId/admin-dashboard/department" element={<Department />} />
          <Route path=":orgId/admin-dashboard/org-details" element={<OrgDetailsBySuperadmin />} />
          <Route path=":orgId/admin-dashboard/city" element={<City />} />
        </Route>
      </Route>

      {/* ADMIN ROUTES */}
      <Route element={<ProtectedRoute allowedRoles={["ADMIN"]} />}>
        <Route path="/admin" element={<AdminDashboard />}>
          <Route index element={<AllOrgsUsers />} />
          <Route path="org-details" element={<OrgDetails />} />
          <Route path="create-user" element={<CreateUser />} />
          <Route path=":orgUserId" element={<CreateUser />} />
          <Route path="vendors" element={<AllVendors />} />
          <Route path="vendors/add-vendor" element={<AddVendor />} />
          <Route path="currency" element={<OrgCurrency />} />
          <Route path="department" element={<OrgDepartment />} />
          <Route path="city" element={<OrgCity />} />
        </Route>
      </Route>

      {/* BUYER / INTERNAL USER ROUTES */}
      <Route element={<ProtectedRoute allowedRoles={["BUYER", "PURCHASE_HEAD", "PURCHASE_MANAGER", "COO", "CFO", "CEO", "CMD"]} />}>
        <Route path="/buyer" element={<BuyerSelection />} />

        {/* Standard eRFQ Dashboard */}
        <Route path="/dashboard" element={<UserDashboard />}>
          <Route index element={<Dashboard />} />
          <Route path="vendors" element={<AllVendors />} />
          <Route path="add-vendor" element={<AddVendor />} />
          <Route path="create-rfq" element={<RFQCreation />} />
          <Route path="create-rfq/draft/:rfqId" element={<RFQCreation />} />
          <Route path=":rfqId" element={<ViewRFQ />} />
          <Route path="view-bid-data/:rfqId" element={<ViewAllBids />} />
          <Route path=":rfqId/query" element={<QueriesTab />} />
        </Route>

        {/* Logistics Buyer Dashboard */}
        <Route path="/logistic-dashboard" element={<UserDashboard />}>
          <Route index element={<LogisticDashboard />} />
          <Route path="logistic-creation" element={<LogisticCreate />} />
          <Route path="logistic-creation/draft/:id" element={<LogisticCreate />} />
          <Route path="view-quotes/:logisticDraftId" element={<ViewLogisticQuotes/>} />
          <Route path=":logisticDraftId/query" element={<LogisticQueriesTab />} />
          <Route path="add-vendor" element={<AddVendor />} />
          <Route path=":logisticDraftId" element={<ViewLogisticDraftDetails />} />
        </Route>

        {/* Logistics Purchase Head Dashboard */}
        <Route path="/logistic-purchase-head-dashboard" element={<UserDashboard />}>
          <Route index element={<LogisticPurchaseHeadDashboard />} />
          <Route path="view-quotes/:logisticDraftId" element={<ViewLogisticQuotes/>} />
          <Route path=":logisticDraftId" element={<ViewLogisticDraftDetails />} />
        </Route>

        {/* Logistics CXO Dashboard */}
        <Route path="/logistic-cxo-dashboard" element={<UserDashboard />}>
          <Route index element={<LogisticCXODashboard />} />
          <Route path="view-quotes/:logisticDraftId" element={<ViewLogisticQuotes/>} />
          <Route path=":logisticDraftId" element={<ViewLogisticDraftDetails />} />
        </Route>
      </Route>

      {/* VENDOR ROUTES */}
      <Route element={<ProtectedRoute allowedRoles={["VENDOR"]} />}>
        <Route path="/vendor/details" element={<VendorDetails />} />

        {/* Standard RFQ Vendor Dashboard
            FIX: All child routes use RELATIVE paths (not absolute /vendor/dashboard/...).
                 In React Router v6, nested routes must use relative paths so they render
                 inside VendorDashboard's <Outlet />. Absolute paths bypass the parent
                 layout so nothing renders inside it.

            FIX: Route ORDER matters — more specific routes must come BEFORE wildcards:
                 - submit-bid/draft/:rfqId  BEFORE  submit-bid/:rfqId
                   (otherwise "draft" gets matched as the rfqId param)
                 - :rfqId/view-query etc   BEFORE  :rfqId
                   (otherwise the wildcard catches everything first)
        */}
        <Route path="/vendor/dashboard" element={<VendorDashboard />}>
          <Route index element={<MyRFQs />} />
          {/* draft route MUST come before :rfqId param route */}
          <Route path="submit-bid/draft/:rfqId" element={<BidSubmission />} />
          <Route path="submit-bid/:rfqId" element={<BidSubmission />} />
          <Route path="submit-rebid/:rfqId" element={<RebidSubmission />} />
          {/* sub-paths MUST come before :rfqId wildcard */}
          <Route path=":rfqId/view-query" element={<ViewQueries />} />
          <Route path=":rfqId/ask-query" element={<AskQuery />} />
          <Route path=":rfqId/view-bids" element={<ViewVendorBids />} />
          <Route path=":rfqId" element={<ViewRFQDetails />} />
        </Route>

        {/* Logistics Vendor Dashboard */}
        <Route path="/vendor/logistic-dashboard" element={<VendorDashboard />}>
          <Route index element={<VendorLogisticsDashboard />} />
          {/* sub-paths MUST come before :logisticDraftId wildcard */}
          <Route path=":logisticDraftId/submit-quote" element={<LogisticBidSubmission />} />
          <Route path=":logisticDraftId/submit-rebid" element={<LogisticRebidSubmission />} />
          <Route path=":logisticDraftId/view-quote" element={<ViewLogisticQuote />} />
          <Route path=":logisticDraftId" element={<ViewLogisticRFQDetails />} />
          <Route path=":logisticDraftId/view-query" element={<ViewQueries />} />
          <Route path=":logisticDraftId/ask-query" element={<AskQuery />} />
        </Route>
      </Route>

      <Route path="*" element={<Login />} />
    </Routes>
  );
}

export default App;
